module.exports = __webpack_public_path__ + "static/media/notification-sound.b00593ca.mp3";